// Design tokens. Single source of truth for raw values.
export const COLORS = {
  red: "#EC1F27",
  redT1: "#F04C53",
  redT2: "#F4797E",
  redT3: "#F8A5A9",
  redT4: "#FBD2D4",

  black: "#231F20",
  blackT1: "#3B3838",
  blackT2: "#605C5C",
  blackT3: "#8C8989",
  blackT4: "#C1C0BF",

  white: "#FFFFFF",
  whiteT1: "#CCCCCC",
  whiteT2: "#999999",
  whiteT3: "#666666",
  whiteT4: "#333333",

  blue: "#2E86DE",
  blueT1: "#589EE5",
  blueT2: "#82B6EB",
  blueT3: "#ABCFF2",
  blueT4: "#D5E7F8",

  amber: "#F59E0B",
  amberT1: "#F7B13C",
  amberT2: "#F9C56D",
  amberT3: "#FBD89D",
  amberT4: "#FDECCE",

  green: "#4CAF50",
  orange: "#FF9800",
  purple: "#9C27B0",
  slate: "#607D8B",
  tomato: "#F44336",
  neonGreen: "#39ff14",
  neonBlue: "#2323ff",
  grey: "#BDBDBD",
  sky: "#42A5F5",
  lilac: "#AB47BC"
} as const;

export const contacts = {
  contacted: COLORS.green,
  notHome: COLORS.orange,
  refused: COLORS.tomato,
  moved: COLORS.purple,
  unvisited: COLORS.blackT4,
  inaccessible: COLORS.slate
} as const;

export const font = {
  heading: "Oswald",
  body: "Inter"
} as const;

export const fontSize = {
  xxs: "0.75rem",
  xs: "0.875rem",
  sm: "1rem",
  md: "1.125rem",
  lg: "1.375rem",
  xl: "1.75rem",
  xxl: "2.5rem"
} as const;

export const statusColors = {
  notStarted: COLORS.grey,
  inProgress: COLORS.sky,
  halfway: COLORS.orange,
  nearlyDone: COLORS.lilac,
  done: COLORS.green
} as const;

export const turfColors = {
  orange: COLORS.orange,
  neonGreen: COLORS.neonGreen,
  neonBlue: COLORS.neonBlue
} as const;

export const neutral = {
  border: COLORS.blackT4,
  divider: COLORS.whiteT1
} as const;

export const layout = {
  drawerWidth: 160
} as const;
